module.exports = __webpack_public_path__ + "img/rule_bg.03f20109.png";